import React, { Component } from 'react';

require(`../assets/${process.env.PAGE}/css/components/adapted-text-area.css`);

class AdaptedTextArea extends Component {

  constructor(props) {
    super(props);
    this.state = {
      availableChars: this.props.maxChars || 0
    }
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange(e) {
    const { availableChars } = this.state;
    const { maxChars } = this.props;
      if (!maxChars || (maxChars && e.target.value.length <= maxChars)) {
        e.target.style.height = 'inherit';
        e.target.style.height = `${e.target.scrollHeight + 6}px`;

        this.setState({ availableChars: maxChars - e.target.value.length });
        this.props.onChange(e);
      }
  }

  render() {

    const { maxChars, ...textarea_props } = this.props;
    const { availableChars } = this.state;

    return (
      <div>
        <textarea {...textarea_props} className={`${this.props.className} adapted-text`} onChange={this.handleOnChange} />
        {maxChars && <div className='available-chars'>{`${availableChars} caracteres restantes.`}</div>}
      </div>
    );
  }
}

export default AdaptedTextArea;


/** WEBPACK FOOTER **
 ** ./src/components/AdaptedTextArea.js
 **/